import { createSelector } from 'reselect';
import { Tier } from 'features/premium/entities';
import { isUnlocked } from 'utils';
import { hasCompletedSetupSelector } from 'features/feed/components/completeSetup/selectors';
import { defaultFeedPriorityArr } from 'features/settings/organize/constants';
import { organizeFeed } from 'features/settings/organize/utils';
import { selectIsCreditScoreAvailable, selectShouldShowCreditScoreInFeed, } from 'features/credit-score/selectors';
import { selectRemovePayTab } from 'features/pay/selectors';
import { selectIsGBUser } from '../selectors';
import { isWeb } from '../../constants';
export const selectRemoveCashbackOffersFromFeed = createSelector([selectIsGBUser], (isGBUser) => isGBUser);
export const selectRemoveGroupsFromFeed = createSelector([selectRemovePayTab, selectIsGBUser], 
// web has no Pay tab, so UK users always get groups in the feed there;
// users outside the UK have the Groups tab instead
(removePayTab, isGBUser) => (isWeb ? !isGBUser : !removePayTab));
export const selectRemoveCreditScoreFromFeed = createSelector([selectIsCreditScoreAvailable, selectShouldShowCreditScoreInFeed], (isAvailable, showInFeed) => !isAvailable || !showInFeed);
export const selectFeedPriority = createSelector([
    (state) => isUnlocked(state.user.user, Tier.pro),
    (state) => state.deviceSettings.feedPersonalization,
    (state) => state.feed.walkthrough?.status,
    hasCompletedSetupSelector,
    selectRemoveCashbackOffersFromFeed,
    selectRemoveCreditScoreFromFeed,
    selectRemoveGroupsFromFeed,
], (canOrganizeFeed, feedPersonalization, walkthroughStatus, hasCompletedSetup, removeCashbackOffers, removeCreditScore, removeGroups) => {
    if (canOrganizeFeed &&
        feedPersonalization &&
        walkthroughStatus !== 'in-progress') {
        return organizeFeed(feedPersonalization, hasCompletedSetup, removeCashbackOffers, removeCreditScore, removeGroups);
    }
    const excluded = {
        completeSetup: hasCompletedSetup,
        cashback: removeCashbackOffers,
        creditScore: removeCreditScore,
        groups: removeGroups,
    };
    return {
        priority: defaultFeedPriorityArr.filter((item) => !excluded[item]),
        removed: [],
    };
});
/**
 * When the credit score card is in its default first position it renders in
 * the Feed screen directly under the overview (its original spot, above the
 * non-organisable cards) instead of inside FeedContent. Dragging it anywhere
 * else moves it into the FeedContent flow.
 */
export const selectIsCreditScoreFirstInFeed = createSelector([selectFeedPriority], ({ priority }) => priority[0] === 'creditScore');
